const LOGIN_RESPONSE = {
  User: 'User',
  WrongPassword: 'WrongPassword',
  UserNotFound: 'UserNotFound',
  EmailNotValidate: 'EmailNotValidate',
};

export default LOGIN_RESPONSE;
